// Components
import { Box, Flex, Text } from 'yard-utilities/components'
import CountdownTimer from './timer/CountdownTimer'

interface CountdownBannerProps {
  discount?: number
}

const CountdownBanner = ({ discount = 77 }: CountdownBannerProps) => {
  return (
    <Box padding={{ sm: [7, 16] }} backgroundColor="red">
      <Flex alignItems="center" justifyContent="space-between">
        <div>
          <Text variant="title-3" textColor="white" spacing={{ sm: 2 }}>
            Limited time offer
          </Text>
          <Text variant="body-6" textColor="white">
            1 year membership at <b>{discount}%</b> off!
          </Text>
        </div>

        <CountdownTimer />
      </Flex>
    </Box>
  )
}

export default CountdownBanner
